import { render, staticRenderFns } from "./Coupon_Placements.vue?vue&type=template&id=fdd9fe36&scoped=true&"
import script from "./Coupon_Placements.vue?vue&type=script&lang=js&"
export * from "./Coupon_Placements.vue?vue&type=script&lang=js&"
import style0 from "./Coupon_Placements.vue?vue&type=style&index=0&id=fdd9fe36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd9fe36",
  null
  
)

export default component.exports